<template>
  <div>
   <!-- 空路由 -->
    <router-view />
  </div>
</template>

<script>
export default {
 
}
</script>



<style>

</style>
